
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1103"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1103",
    "ar-eg": "static-7.1103",
    "bg": "static-7.1103",
    "bn": "static-7.1103",
    "ca-es": "static-7.1103",
    "cs": "static-7.1103",
    "da": "static-7.1103",
    "de": "static-7.1103",
    "el": "static-7.1103",
    "en-gb": "static-7.1103",
    "en": "static-7.1103",
    "es-mx": "static-7.1103",
    "es": "static-7.1103",
    "et": "static-7.1103",
    "fi": "static-7.1103",
    "fr-ca": "static-7.1103",
    "fr": "static-7.1103",
    "he-il": "static-7.1103",
    "hi": "static-7.1103",
    "hr": "static-7.1103",
    "hu": "static-7.1103",
    "id": "static-7.1103",
    "it": "static-7.1103",
    "ja": "static-7.1103",
    "ko": "static-7.1103",
    "lt": "static-7.1103",
    "ms": "static-7.1103",
    "nl": "static-7.1103",
    "no": "static-7.1103",
    "pl": "static-7.1103",
    "pt-br": "static-7.1103",
    "pt-pt": "static-7.1103",
    "ro": "static-7.1103",
    "ru": "static-7.1103",
    "sk": "static-7.1103",
    "sl": "static-7.1103",
    "sv": "static-7.1103",
    "th": "static-7.1103",
    "tl": "static-7.1103",
    "tr": "static-7.1103",
    "uk": "static-7.1103",
    "vi": "static-7.1103",
    "x-pseudo": "static-7.1103",
    "zh-cn": "static-7.1103",
    "zh-hk": "static-7.1103",
    "zh-tw": "static-7.1103"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1103'}); }
})();


